/**
 * Retry a function on a given interval as long as it does not throw an error.
 * 
 * @param interval Time between retry attempts in milliseconds. Default 500ms.
 * @param initialWait Time to wait for first attempt. Default 500ms.
 * @param retryAttemptsOnError Maxium number of retries if the wrapped function throws. Default is 2.
 */
// eslint:disable: no-string-based-set-timeout
export async function retry<T>(
  fn: () => Promise<T>,
  interval: number = 500,
  initialWait: number = 0,
  retryAttemptsOnError: number = 2
): Promise<T> {
  try {
    initialWait && await new Promise(r => setTimeout(r, initialWait));
    // Await to close in errors thrown. This enables retry-on-error.
    return await fn();      
  } catch (error) {
    if (retryAttemptsOnError > 0) {              
      await new Promise(r => setTimeout(r, interval));
      return retry(
        fn,
        interval,  
        initialWait,        
        retryAttemptsOnError - 1
      );
    } else {
        throw new Error('Reached max retries due to Error: ' + error.message);
    }
  }
}
